import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M21 3l-5 9h5l-6.891 7.086a6.5 6.5 0 1 1 -8.855 -9.506l7.746 -6.58l-1 5l9 -5","key":"svg-0"}],["path",{"d":"M7 14.5a2.5 2.5 0 1 0 5 0a2.5 2.5 0 1 0 -5 0","key":"svg-1"}]]

const IconMeteor = createReactComponent('outline', 'meteor', 'Meteor', __iconNode);

export default IconMeteor;